// The documents index's own sorts (Query::Documents::Elastic SORTABLE_ATTRIBUTES),
// labelled once for the pages that sort documents. The interpretation dates the
// index can also sort by are left out: no documents list offers them. `date` is
// the document date: effective, else instrument, file, recorded.
export interface DocumentSort {
  attribute: string;
  label: string;
  isDate: boolean;
}

// The search page's date sorts, in its dropdown order.
type SearchPageSortId =
  | 'effective_date'
  | 'file_date'
  | 'instrument_date'
  | 'recorded_date'
  | 'created_at'
  | 'updated_at';

const SEARCH_PAGE_SORTS: (DocumentSort & { attribute: SearchPageSortId })[] = [
  { attribute: 'effective_date', label: 'Effective Date', isDate: true },
  { attribute: 'file_date', label: 'File Date', isDate: true },
  { attribute: 'instrument_date', label: 'Instrument Date', isDate: true },
  { attribute: 'recorded_date', label: 'Recorded Date', isDate: true },
  { attribute: 'created_at', label: 'Created At', isDate: true },
  { attribute: 'updated_at', label: 'Updated At', isDate: true },
];

export const DOCUMENT_SORTS: DocumentSort[] = [
  { attribute: 'date', label: 'Document Date', isDate: true },
  { attribute: 'title', label: 'Document', isDate: false },
  { attribute: 'document_type', label: 'Document Type', isDate: false },
  ...SEARCH_PAGE_SORTS,
];

type SortField = {
  id: SearchPageSortId;
  text: string;
  direction: 'ASC' | 'DESC';
};

// The search page's sort dropdown: each of its dates, newest then oldest.
export const sortFields: SortField[] = SEARCH_PAGE_SORTS.flatMap(
  ({ attribute, label }) => [
    { id: attribute, text: `${label} - Newest`, direction: 'DESC' as const },
    { id: attribute, text: `${label} - Oldest`, direction: 'ASC' as const },
  ]
);

export type { SortField };
